import apiClient from "@/shared/api/apiClient2";

export const signParticipant = async (transaction_id, params) => {
  const result = await apiClient.post(
    `/signatures/${transaction_id}/sign-participant`,
    {
      ...params,
    }
  );
  return result.data;
};

export const signatureValidate = async (signature_uuid) => {
  const result = await apiClient.post(`/signatures/validate/${signature_uuid}`);
  return result.data;
};

export const getSignatureList = async (transaction_id) => {
  const result = await apiClient.get(`/signatures/${transaction_id}`);
  return result.data;
};

export const getCurrentSignParticipant = async (transaction_id) => {
  const result = await apiClient.get(
    `/signatures/${transaction_id}/current-signer`
  );
  return result.data;
};

export const verifyChainSign = async (transaction_id) => {
  const result = await apiClient.get(
    `/signatures/${transaction_id}/verify-chain`
  );
  return result.data;
};

export const signNotary = async (transaction_id, params) => {
  const result = await apiClient.post(
    `/signatures/${transaction_id}/sign-notary`,
    {
      ...params,
    },
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};

export const rejectNotary = async (signature_uuid, params) => {
  const result = await apiClient.post(
    `/signatures/${signature_uuid}/reject`,
    {
      ...params,
    },
    {
      metaData: { isNotificationDisabled: true },
    }
  );
  return result.data;
};
